var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoteWorxGuideIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    stroke: "#C9C7E4",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92296 11.4516C8.92296 11.1398 9.02617 10.8387 9.23259 10.5484C9.43901 10.2581 9.76494 9.92473 10.2104 9.54839C10.6558 9.15054 10.9546 8.84409 11.1067 8.62903C11.2588 8.41398 11.3348 8.16129 11.3348 7.87097C11.3348 7.49462 11.2044 7.1828 10.9437 6.93548C10.6938 6.68817 10.3842 6.56452 10.0148 6.56452C9.27605 6.56452 8.74914 7.02688 8.43407 7.95161L7 7.33871C7.22815 6.58602 7.6084 6.01075 8.14074 5.6129C8.68395 5.2043 9.33037 5 10.08 5C10.9274 5 11.6444 5.26344 12.2311 5.79032C12.8178 6.30645 13.1111 6.95699 13.1111 7.74193C13.1111 8.2043 12.997 8.62903 12.7689 9.01613C12.5407 9.39247 12.1714 9.80107 11.6607 10.2419C11.1936 10.6505 10.884 10.9516 10.7319 11.1452C10.5798 11.328 10.5037 11.5323 10.5037 11.7581C10.5037 11.8871 10.5254 12.0323 10.5689 12.1935H9.10222C8.98272 11.9247 8.92296 11.6774 8.92296 11.4516ZM8.98815 15.6452C8.74914 15.4086 8.62963 15.1129 8.62963 14.7581C8.62963 14.4032 8.74914 14.1075 8.98815 13.871C9.23802 13.6237 9.54222 13.5 9.90074 13.5C10.2593 13.5 10.558 13.6183 10.797 13.8548C11.0469 14.0914 11.1719 14.3925 11.1719 14.7581C11.1719 15.1129 11.0469 15.4086 10.797 15.6452C10.558 15.8817 10.2593 16 9.90074 16C9.54222 16 9.23802 15.8817 8.98815 15.6452Z",
    fill: "#C9C7E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteWorxGuideIcon);
export default __webpack_public_path__ + "static/media/RemoteWorxGuideIcon.a362dc3eb5841b4bd0bd7eb7d05c34a4.svg";
export { ForwardRef as ReactComponent };